import { Route } from 'react-router-dom';
import { AlertDisplay, OAuthRequestDialog } from '@backstage/core-components';
import { createApp } from '@backstage/app-defaults';
import { AppRouter, FlatRoutes, FeatureFlagged } from '@backstage/core-app-api';
import { TechRadarPage } from '@backstage-community/plugin-tech-radar';
import { SignalsDisplay } from '@backstage/plugin-signals';
import {
  defaultAppComponents,
  bindDefaultRoutes,
  routes as defaultRoutes,
  ConfigToFeatureFlagHandlerProps,
  ConfigToFeatureFlagHandler,
  VisitListener,
} from '@platt-internal/backstage-plugin-bootstrap-react';
import { faqsAppRoutes } from '@platt/backstage-plugin-bootstrap-faqs-react';
import { apis } from './apis';
import { entityPage } from './components/catalog/EntityPage';
import { Root } from './components/Root';
import { AzPolicyPage } from '@platt/backstage-plugin-az-policy';

const app = createApp({
  apis,
  components: {
    ...defaultAppComponents,
  },
  bindRoutes({ bind }) {
    bindDefaultRoutes({ bind });
  },
  featureFlags: [],
});

const routes = (
  <FlatRoutes>
    {defaultRoutes({ entityPage })}

    {/* additional routes */}
    {faqsAppRoutes()}
    <Route
      path="/tech-radar"
      element={<TechRadarPage width={1500} height={800} />}
    />
    <FeatureFlagged with="az-policy-enabled">
      <Route path="/az-policy" element={<AzPolicyPage />} />
    </FeatureFlagged>
  </FlatRoutes>
);

const configHandlersProps: ConfigToFeatureFlagHandlerProps = {
  checks: [
    {
      isEnable: config => config.getOptionalBoolean('spotify.enabled') ?? false,
      featureFlagName: 'spotify-plugins',
    },
  ],
};

export default app.createRoot(
  <>
    <AlertDisplay />
    <OAuthRequestDialog />
    <ConfigToFeatureFlagHandler {...configHandlersProps} />
    <SignalsDisplay />
    <AppRouter>
      <VisitListener />
      <Root>{routes}</Root>
    </AppRouter>
  </>,
);
